import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const UpdateRoleDtoSchema = z.object({
  id: z.number(),
  name: z.string(),
});

const UpdateRoleResponseDtoSchema = z.object({
  id: z.string(),
  name: z.string(),
  organizationId: z.string().nullable(),
});

export type UpdateRoleRequestDto = z.infer<typeof UpdateRoleDtoSchema>;
export type UpdateRoleResponseDto = z.infer<typeof UpdateRoleResponseDtoSchema>;

export const updateRole = (
  dto: UpdateRoleRequestDto,
  config?: AxiosRequestConfig<UpdateRoleRequestDto>
) => {
  const { id, ...data } = UpdateRoleDtoSchema.parse(dto);
  return api
    .patch(`/roles/${id}`, data, config)
    .then(responseContract(UpdateRoleResponseDtoSchema));
};
